module.exports = __webpack_public_path__ + "il.8cfa7ba1.svg";